import { useState } from 'react';
import { generatePassword } from '@battini/crypto';
import { CopyButton } from '../components/ui.js';
import { PasswordStrength } from '../components/PasswordStrength.js';

export function PasswordGeneratorPage() {
  const [length, setLength] = useState(24);
  const [upper, setUpper] = useState(true);
  const [lower, setLower] = useState(true);
  const [numbers, setNumbers] = useState(true);
  const [symbols, setSymbols] = useState(true);
  const [avoidAmbiguous, setAvoidAmbiguous] = useState(true);
  const [pw, setPw] = useState(() => generatePassword({ length, uppercase: upper, lowercase: lower, numbers, symbols, avoidAmbiguous }));

  const regen = () => setPw(generatePassword({ length, uppercase: upper, lowercase: lower, numbers, symbols, avoidAmbiguous }));

  return (
    <div style={{ maxWidth: 720 }}>
      <div className="panel mb">
        <div className="mono" style={{ fontSize: 22, wordBreak: 'break-all', minHeight: 32 }}>{pw}</div>
        <div className="mt-sm"><PasswordStrength password={pw} /></div>
        <div className="flex mt" style={{ gap: 8 }}>
          <button className="btn" onClick={regen}>🔄 Regenerate</button>
          <CopyButton value={pw} label="Copy password" className="btn secondary" />
        </div>
      </div>

      <div className="panel">
        <div className="field">
          <label>Length: <strong>{length}</strong></label>
          <input type="range" min={8} max={64} value={length} onChange={(e) => { setLength(Number(e.target.value)); }} onMouseUp={regen} onTouchEnd={regen} />
        </div>
        <div className="row2">
          <label className="flex"><input type="checkbox" checked={upper} onChange={(e) => setUpper(e.target.checked)} /> Uppercase (A–Z)</label>
          <label className="flex"><input type="checkbox" checked={lower} onChange={(e) => setLower(e.target.checked)} /> Lowercase (a–z)</label>
          <label className="flex"><input type="checkbox" checked={numbers} onChange={(e) => setNumbers(e.target.checked)} /> Numbers (0–9)</label>
          <label className="flex"><input type="checkbox" checked={symbols} onChange={(e) => setSymbols(e.target.checked)} /> Symbols (!@#$…)</label>
          <label className="flex"><input type="checkbox" checked={avoidAmbiguous} onChange={(e) => setAvoidAmbiguous(e.target.checked)} /> Avoid ambiguous (Il1O0)</label>
        </div>
        <button className="btn secondary full mt" onClick={regen}>Apply & regenerate</button>
      </div>
    </div>
  );
}
